import { ILogger } from '@cian/logger';

interface IParams {
  logger: ILogger;
  platform: string;
}

export const getAppMeta = ({ logger, platform }: IParams): Record<string, string> | null => {
  try {
    const fvuAnalyticsMetaStr = sessionStorage.getItem('FvuAnalyticsMeta');
    const appMeta = fvuAnalyticsMetaStr && JSON.parse(fvuAnalyticsMetaStr);

    return appMeta;
  } catch (e) {
    logger.error(e, {
      description: `Ошибка парсинга данных аналитики в приложении ${platform}`,
      degradation: `Не отправятся мета данные аналитики из ${platform}`,
    });

    return null;
  }
};
